import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Loading, SocietyPageHeader } from "../../components/shared";
import { ExternalLink, Save, Settings } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";

export default function SocietySettings() {
  const [form, setForm] = useState(null);
  const load = () => api.get("/societies/me").then((response) => setForm(response.data));

  useEffect(() => {
    load();
  }, []);

  const set = (k, v) => setForm({ ...form, [k]: v });

  const save = async () => {
    try {
      await api.put("/societies/me", form);
      toast.success("Advanced settings saved");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Could not save");
    }
  };
  if (!form) return <Loading />;
  return (
    <div className="max-w-3xl">
      <SocietyPageHeader
        icon={Settings}
        tone="violet"
        subtitle="Manage operational defaults that are not part of your Society Profile."
        title="Society Settings"
      />
      <div className="bg-card border rounded-xl p-6 grid grid-cols-2 gap-4">
        <F label="Society Name" span><Input data-testid="settings-name" value={form.name || ""} onChange={(e) => set("name", e.target.value)} /></F>
        <F label="Registration Number"><Input value={form.registration_number || ""} onChange={(e) => set("registration_number", e.target.value)} /></F>
        <F label="Financial Year"><Input value={form.financial_year || ""} onChange={(e) => set("financial_year", e.target.value)} /></F>
        <F label="Address" span><Input value={form.address || ""} onChange={(e) => set("address", e.target.value)} /></F>
        <F label="City"><Input value={form.city || ""} onChange={(e) => set("city", e.target.value)} /></F>
        <F label="State"><Input value={form.state || ""} onChange={(e) => set("state", e.target.value)} /></F>
        <F label="PIN Code"><Input value={form.pincode || ""} onChange={(e) => set("pincode", e.target.value)} /></F>
        <F label="Buildings"><Input type="number" value={form.buildings || 0} onChange={(e) => set("buildings", +e.target.value)} /></F>
        <F label="Wings"><Input value={form.wings || ""} onChange={(e) => set("wings", e.target.value)} /></F>
        <F label="Total Flats"><Input type="number" value={form.flats || 0} onChange={(e) => set("flats", +e.target.value)} /></F>
        <F label="Secretary Name"><Input value={form.secretary_name || ""} onChange={(e) => set("secretary_name", e.target.value)} /></F>
        <F label="Secretary Mobile"><Input value={form.secretary_mobile || ""} onChange={(e) => set("secretary_mobile", e.target.value)} /></F>
      </div>
      <Button onClick={save} className="rounded-full gap-2 mt-4" data-testid="settings-save"><Save className="w-4 h-4" /> Save Changes</Button>

      <div className="mt-6 border-l-4 border-emerald-600 bg-emerald-50 p-5">
        <p className="font-medium text-slate-950">Society Profile &amp; Letterhead</p>
        <p className="mt-1 text-sm text-slate-600">
          Official identity, logo, and printable Letterhead are managed in Society Setup so
          documents use one Society-owned profile.
        </p>
        <div className="mt-4 flex flex-wrap gap-3">
          <a data-testid="advanced-settings-profile-link" href="/app/setup">
            <Button size="sm" variant="outline">
              <ExternalLink className="h-4 w-4" />
              Open Society Setup
            </Button>
          </a>
          <a data-testid="advanced-settings-letterhead-link" href="/app/letterhead">
            <Button size="sm" variant="outline">
              <ExternalLink className="h-4 w-4" />
              Preview Letterhead
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
}
function F({ label, children, span }) {
  return <div className={span ? "col-span-2" : ""}><Label className="mb-1.5 block text-sm">{label}</Label>{children}</div>;
}
